import React, { FC } from 'react'
import { Icon } from 'antd'

import { TabConfig } from '../../types'
import ActivityPage from './Activity'
import { Page, RoutedTabs } from '../../components'
import { useAuth } from '../../providers/AuthProvider'

const AdminPage: FC = () => {
	const { userHasPermission } = useAuth()
	const tabs: TabConfig[] = []

	if (userHasPermission(['Activity.All.Read'])) {
		tabs.push({
			id: 'activity',
			title: (
				<>
					<Icon type='solution' /> Activity Log
				</>
			),
			render: (): React.ReactNode => <ActivityPage />
		})
	}

	return (
		<Page title={'Admin'}>
			<RoutedTabs tabs={tabs} />
		</Page>
	)
}

export default AdminPage
